import { ADD_PART_TO_WORKSPACE_SUCCESS } from './addPartToWorkspaceRequest';

export const addPartToWorkspaceSuccess = () => ({
  type: ADD_PART_TO_WORKSPACE_SUCCESS,
  payload: {
  }
});
